import { getDefaultFormData } from '@/app/(main)/clients/create/utils/getDefaultFormData';
import type { GetPassportClientData } from '@/types/clientDetailsApiTypes';
import type { ClientDocumentWithPassportData, GetRelatedPassengersData } from '@/types/clientsApiTypes';
import type { RelatedPassengerPreferencesData } from '@/types/clientsApiTypes';
import { ModalKeys } from '../../../../components/EditSectionModals/types';
import type { ModalKey } from '../../../../components/EditSectionModals/types';
import type { ClientDataWithAdditionalData, GetClientDataWithAdditionalData } from '../../../types';
import { mapClientForDefaultFormData } from '../mapClientForDefaultFormData';

export const getDataForEditModals = (
  key: ModalKey,
  client?: GetClientDataWithAdditionalData,
  documentsData?: ClientDocumentWithPassportData[],
  relatedPassengers?: GetRelatedPassengersData[],
  passportData?: GetPassportClientData[]
): ClientDataWithAdditionalData => {
  const formData = {
    ...getDefaultFormData(
      mapClientForDefaultFormData(client),
      documentsData ?? [],
      relatedPassengers ?? [],
      passportData ?? undefined
    ),
    important_dates: client?.important_dates ?? [],
    passport: client?.passport,
  };

  if (key === ModalKeys.related_allergies) {
    const relatedPreferenceData = client?.preferences?.preference_data as RelatedPassengerPreferencesData | undefined;
    const fly = relatedPreferenceData?.fly;
    const relatedAllergiesFly = formData.primary_passenger.preference_data.fly as unknown as {
      fly_private_aviation?: 'yes' | 'no' | null;
      seat?: 'Window' | 'Aisle' | null;
      class_preference?: [];
    };

    relatedAllergiesFly.fly_private_aviation =
      fly?.fly_private_aviation === 'yes' || fly?.fly_private_aviation === 'no' ? fly?.fly_private_aviation : null;
    relatedAllergiesFly.seat = fly?.seat ?? null;
    relatedAllergiesFly.class_preference = [];
  }

  return formData;
};